import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { FlatpickrDirective, provideFlatpickrDefaults } from "angularx-flatpickr";
import dayjs from "dayjs";

import { AfterViewInit, ChangeDetectionStrategy, Component, computed, inject, input, output } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { SearchFilter, Severity } from "../../../apis/networkdashboard/graphql/graphql";
import { AuthService } from "../../../services/authservice";
import { CustomDropdown } from "../../common/custom-dropdown/custom-dropdown";

@Component({
  selector: "cert-filter",
  templateUrl: "cert-filter.html",
  styleUrls: ["cert-filter.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CustomDropdown, AngularSvgIconModule, FormsModule, TranslatePipe, FlatpickrDirective],
  providers: [provideFlatpickrDefaults()],
})
export class CertFilter implements AfterViewInit {
  private auth = inject(AuthService);

  prefixes = input<string[]>([]);
  filtersChanged = output<SearchFilter>();

  public initialStartDate: Date = new Date();
  public initialEndDate: Date = new Date();
  public enableSpecificFilters = false;

  public classifications = [
    { id: 1, select: false, name: "critical", value: Severity.Critical },
    { id: 2, select: false, name: "high", value: Severity.High },
    { id: 3, select: false, name: "medium", value: Severity.Medium },
    { id: 4, select: false, name: "low", value: Severity.Low },
    { id: 5, select: false, name: "info", value: Severity.Info },
  ];

  public ip = "";

  public scanOptions = [
    { id: 1, select: false, name: "Scan option 1" },
    { id: 2, select: false, name: "Scan option 2" },
  ];

  public prefixOptions = computed(() =>
    this.prefixes()
      .map((prefix: string, index: number) => ({
        id: index,
        select: false,
        name: prefix,
      }))
      .sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      }),
  );

  constructor() {
    this.initialStartDate.setDate(this.initialStartDate.getDate() - 7);
  }

  submit() {
    this.filtersChanged.emit(this.searchFilter());
  }

  onFilterChanged() {}

  searchFilter(): SearchFilter {
    const filter: SearchFilter = {};

    const selectedPrefixes = this.prefixOptions().filter((prefix) => prefix.select);
    if (selectedPrefixes.length) {
      filter.ipPrefixesSource = selectedPrefixes.map((prefix) => prefix.name as string);
    }

    filter.customerId = this.auth.viewingCustomer().customerId;
    const selectedClassifications = this.classifications.filter((prefix) => prefix.select);
    if (selectedClassifications.length) {
      filter.severity = selectedClassifications.map((prefix) => prefix.value as Severity);
    }

    filter.afterSourceDate = dayjs(this.initialStartDate).startOf("day").toDate();
    filter.beforeSourceDate = dayjs(this.initialEndDate).endOf("day").toDate();

    if (this.ip !== "") {
      filter.ip = `${this.ip}`.trim().replace(/[^0-9.]/g, "");
    }

    return filter;
  }

  ngAfterViewInit(): void {
    this.filtersChanged.emit(this.searchFilter());
  }

  resetFilters() {
    this.ip = "";

    this.prefixOptions().map((prefix) => {
      prefix.select = false;
    });

    this.classifications.map((prefix) => {
      prefix.select = false;
    });

    this.initialStartDate = dayjs().subtract(7, "day").startOf("day").toDate();
    this.initialEndDate = dayjs().endOf("day").toDate();

    this.filtersChanged.emit(this.searchFilter());
  }
}
